import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { StorageService } from './service/storage.service';
import { EncryptionService } from './service/encryption.service';
import { DataService } from './service/data.service';
import { Subscription } from 'rxjs';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { ConstantService } from './service/constant.service';
import { DataLoginService } from './service/dataLogin.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})

export class AppComponent implements OnInit {
  headerMenushowHide = true;
  urlEndPoint = '';  
  emailId: string;
  jwtToken: string;
  accessToken: string
  portalNumber: string;
  mainBaseArray = [];
  
  private routeSubscription: Subscription;

  constructor( @Inject(APP_SETTINGS) private settings: AppSettings,
    private route: ActivatedRoute,
    private router: Router,
    private forumApiService: ForumApiService,
    private storageService: StorageService,
    private encryptionService: EncryptionService,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private constantService: ConstantService,
    private dataLoginService: DataLoginService,
    ) {}
  
  ngOnInit(): void {
    this.checkLogin();
    this.getPortalId();

    this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.route)
      ).subscribe((route: ActivatedRoute) => {
        let currentRoute = route;
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }
        if (currentRoute.snapshot && currentRoute.snapshot.url && currentRoute.snapshot.url.length > 0) {
          this.urlEndPoint = currentRoute.snapshot.url[0].path;
        } else {
          this.urlEndPoint = '';
        }
      });

    this.routeSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkRoute();
    });
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  checkRoute(): void {
    const activeRoute = this.activatedRoute.snapshot.firstChild;
    if (activeRoute) {
      const { cname, sname, qname} = activeRoute.params;
      if (cname && sname && qname) {
        this.headerMenushowHide = false;
      } else if(this.urlEndPoint === this.constantService.navigationComponentPage.createTicket) {
        this.headerMenushowHide = false;
      } else {
        this.headerMenushowHide = true;
      }
    } else {
      this.headerMenushowHide = true;
    }
  }

  async checkLogin(): Promise<void>  {
    try {

      const request = {
        head: {
          appName: this.constantService.checkLoginRequestConstant.appName,
          appSource: this.constantService.checkLoginRequestConstant.appSource,
          appVer: this.constantService.checkLoginRequestConstant.appVer,
          key: this.constantService.checkLoginRequestConstant.key,
          osName: this.constantService.checkLoginRequestConstant.osName,
          requestCode: this.constantService.checkLoginRequestConstant.requestCode,
        },
        body: {},
      };

      await this.forumApiService.CheckLoginResponse(request)
      .then(async loginresponse => {      
        if (
          loginresponse != '' &&
          loginresponse != undefined &&
          loginresponse.head.statusDescription != this.constantService.invalidSessionText)
        {
          this.storageService.setItem(this.constantService.isLoggedIn,this.constantService.yes);
          this.storageService.setItem(this.constantService.clientCode, this.encryptionService.encryptUsingAES_256(loginresponse.body.ClientCode));
          this.storageService.setItem(this.constantService.jwtToken, this.encryptionService.encryptUsingAES_256(loginresponse.head._5Pjwt));
          
          this.dataLoginService.sendData(this.constantService.yes);

          this.clientPersonalDetails();
        } else {
          this.dataLoginService.sendData(this.constantService.no);
          this.storageService.setItem(this.constantService.isLoggedIn,this.constantService.no);
        }
      });

    } catch(e){
      console.log(e);
    }
  }

  async getPortalId(): Promise<void> {
    try {
      const orgId = this.encryptionService.decryptUsingAES_256(this.settings.orgId);

      await this.forumApiService
        .getPortalId(orgId)
        .then(async (getPortalIdResponse) => {
          if (getPortalIdResponse.data.length > 0) {
            for (let i = 0; i < getPortalIdResponse.data.length; i++) {
              if (getPortalIdResponse.data[i].name == this.constantService.fivePaisaText) {
                this.portalNumber = getPortalIdResponse.data[i].portalId;
                this.storageService.setItem(
                  this.constantService.portalId,
                  this.encryptionService.encryptUsingAES_256(this.portalNumber)
                );
              }
            }
          }         
        });
            this.knowledgeBase();
    } catch (e) {
      console.group('Error Occured in getPortalId : ', e);
    }
  }

  async knowledgeBase(): Promise<void> {
    try {
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
      const include = this.constantService.knowledgeBaseRequestInclude;
      await this.forumApiService.knowledgeBase(include, portalId).then(async (knowledgeBaseResponse) => {
          for(let i=0; i<knowledgeBaseResponse.child.length; i++){
            this.mainBaseArray[i] = knowledgeBaseResponse.child[i];
          }
          this.dataService.sendData(this.mainBaseArray);
      });
    } catch (e) {
      console.group('Error Occured in knowledgeBase : ', e);
    }
  }

  async clientPersonalDetails() {
    try {
      // this.showLoader = true;
      const auth = 'Bearer ' + this.encryptionService.decryptUsingAES_256(this.storageService.getItem('jwtToken'));
      const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem('clientCode'));

      const request =
      {
        "head": {
            "appVer": "1.0",
            "appName": "5P",
            "osName": "WEB",
            "key": "kahdAjhfdsd423jkoi3frDFD3vbxvzyXZ4S4dF"
        },
        "body": {
            "ClientCode": clientId
        }
    }    
      
      await this.forumApiService.clientPersonalDetails(auth, request).then(async (clientPersonalDetailsResponse) => {
        console.log('Client Personal Details Response - ',clientPersonalDetailsResponse);

        if(clientPersonalDetailsResponse.head.Status == 0 && clientPersonalDetailsResponse.body.Message == 'Success'){
          this.emailId = clientPersonalDetailsResponse.body.clientInfoResult.ClientInfo[0].br_email;
          this.getAccessToken();
        } else {
          console.log('Error in Client Personal Details');
        }

      });
    } catch (e) {
      // this.showLoader = false;
      console.log('Error Occured in clientPersonalDetails : ', e);
    }
  }

  async getAccessToken(): Promise<void> {
    try {
      // this.showLoader = true;
      const request = {
        "data": this.emailId
      }      
      await this.forumApiService.getAccessTokenForJwt(request).then(async (getAccessTokenForJwtResponse) => {
        if(getAccessTokenForJwtResponse.statusCode == '0'){
          this.accessToken = getAccessTokenForJwtResponse.access_token;
          this.getJwtToken(this.accessToken);
        }
      });
    } catch (e) {
      // this.showLoader = false;
      console.group('Error Occured in getAccessToken : ', e);
    }
  }

  async getJwtToken(accessToken): Promise<void> {
    try {
      // this.showLoader = true;
      const request = {
        "EmailID": this.emailId
      }      
      await this.forumApiService.getJwtToken(accessToken , request).then(async (getJwtTokenResponse) => {
        if(getJwtTokenResponse.statusCode == '0'){
          // this.showLoader = false;
          this.jwtToken = getJwtTokenResponse.access_token;
          this.storageService.setItem('jwtTokenForZoho',this.jwtToken);

        
        if (
          this.storageService.getItem('isReload') !== 'Y' ||
          this.storageService.getItem('isReload') == null &&
          this.storageService.getItem('jwtTokenForZoho')
        ) {
          setTimeout(() => {
            this.storageService.setItem('isReload', 'Y');
            window.location.reload();
          }, 800);
        } 
          
          
          // (window as any).openTicketsTab();
          
        }
      });
    } catch (e) {
      // this.showLoader = false;
      console.group('Error Occured in getJwtToken : ', e);
    }
  }

}